module.exports = __webpack_public_path__ + "static/topic-3-e1956e64f9fc66a8b0d91f7563248afb.jpg";